@if (leverantorsorder) {
<rask-page [pageTitle]="pageTitle">
    <ng-container headerContent>
        <rask-copy-leverantorsorder-header [orderHeader]="header" [leverantorsorder]="leverantorsorder"
            [rootForm]="rootForm" [validationContext]="validationContext"></rask-copy-leverantorsorder-header>
    </ng-container>
    <rask-toggle-list>
        <ng-container list-header>
            <rask-label size="3">{{'LEVERANTORSORDER_DETAIL_ROW_HANDELSSORTIMENTSGRUPP' | translate}}</rask-label>
            <rask-label size="1">Avtals&shy;kvantitet</rask-label>
            <rask-label style="width:120px;max-width:none;">{{'LEVERANTORSORDER_DETAIL_ROW_MATTSLAG' |
                translate}}</rask-label>
            <rask-label style="width:160px;max-width:none;">{{'DEFAULT_PERIODFROM' | translate}}</rask-label>
            <rask-label style="width:160px;max-width:none;">{{'DEFAULT_PERIODTOM' | translate}}</rask-label>
            <rask-label>{{'LEVERANTORSORDER_EGEN_BEFRAKTNING' | translate}}</rask-label>
            <rask-label>Kopiera</rask-label>
        </ng-container>
        @for (leverantorsorderrad of leverantorsorder?.leverantorsorderrader; track leverantorsorderrad) {
        <rask-toggle-list-item>
            <ng-container item-header>
                <rask-leverantorsorderrad-edit
                    [order]="leverantorsorder"
                    [rootForm]="rootForm"
                    [showLabels]="false"
                    [leverantorsorderrad]="leverantorsorderrad"
                    [isCopy]="true">
                </rask-leverantorsorderrad-edit>
            </ng-container>
        </rask-toggle-list-item>
        }
    </rask-toggle-list>
    <ng-container footerContent>
        <rask-save-button [disabled]="!canSave()" (click)="save()"></rask-save-button>
    </ng-container>
</rask-page>
}